import React, { useState } from "react";

const Subscribe = () => {
  const [dataBlock] = useState({
    title: "Subcribe Of Our New Versions",
    subTitle:
      "Due to its widespread use as filler text for layouts, non-readability is of great importance.",
  });
  return (
    <>
      <section className="py-20">
        <div className="container">
          <div className="grid grid-cols-1">
            <div className="text-center">
              <h2 className="font-bold text-[32px] md:text-[40px] capitalize mb-2 relative z-10">
                <span className="bg-[#dff1f0] h-[70px] w-[70px] inline-block absolute rounded-full -z-10 -top-[15px]"></span>
                {dataBlock.title}
              </h2>
              <p className="text-muted mx-auto text-lg max-w-[600px] mt-6">
                {dataBlock.subTitle}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 mt-16">
            <div>
              <form className="flex flex-col sm:flex-row justify-center items-center max-w-[500px] mx-auto gap-2">
                <div className="relative w-full">
                  <i className="mdi mdi-email-outline absolute z-10 leading-[52px] left-4 text-xl text-muted"></i>
                  <input
                    type="email"
                    className="form-input w-full focus:border-custom border pl-[48px] border-[#ced4da] rounded-full position-relative h-[52px]"
                    placeholder="Your Email"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                  />
                </div>
                <button type="submit" className="btn-custom rounded-full">
                  Subcribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Subscribe;
